import { Slide,toast } from "react-toastify";
import './CustomToastify.css'
const CustomToast = ({text,type}:any) => (
  
    <div className="toastifyBody">
      {text?.Target === '' ? 
     <p className="text"><b>{text?.s_code}</b>, Stoploss Modified to {Number(text?.Stoploss)?.toFixed(2)} at {text?.time}</p>
     :text?.Stoploss === '' ? 
    <p className="text"><b>{text?.s_code}</b>, Target Modified to {Number(text?.Target)?.toFixed(2)} at {text?.time}</p>
     :
     text?.Target &&  text?.Stoploss ?
     <p className="text"><b>{text?.s_code}</b>, Target Modified to {Number(text?.Target)?.toFixed(2)} and Stoploss Modified to {Number(text?.Stoploss)?.toFixed(2)} at {text?.time}</p> :''
      }
    </div>
  );

  const CustomToastDelete = ({text}:any) => (
  
    <div className="toastifyBodyDelete">
      {text?.n_pl >= 0 ? <img src="/icons/trending.png" alt="Down" /> :<img src="/icons/recession.png" alt="Down" />}
      

     <p className="text"><b>{text?.s_symbol} ({text?.s_code})</b> <br/>Trade closed due to <b>{text?.s_status}</b> at {text?.dt_exit_time} with pl <b>{text?.n_pl}</b></p>
   
    </div>
  );


  export const customToast = (data:any,type:string) => {

    if(type != 'delete') {
      toast.info(<CustomToast  text={data} />, 
      { 
        toastId: "unique-success-delete",
        theme: "dark",
      transition: Slide,
      autoClose:4000,
      closeOnClick: true,
    });
    }

    else{
      toast(<CustomToastDelete  text={data} />, 
      { 
        toastId: "unique-success-delete",

        theme: "dark",
      transition: Slide,
      autoClose:4000,
      closeOnClick: true,
    });
    }
    
  };